﻿import { AdsApi, ShowInterstitialAdOptions, ShowRewardedAdOptions } from './AdsApi.ts'
import { createMockDelay, MOCK_DELAYS } from '../rundot-game-api/systems/core.js'
import { MockOverlay } from '../MockOverlay'
import { mockLog } from '../MockDebug'

const TAG = 'Mock Ads'

export class MockAdsApi implements AdsApi {
  private mockOverlay: MockOverlay

  constructor(mockOverlay: MockOverlay) {
    this.mockOverlay = mockOverlay
  }

  async isRewardedAdReadyAsync(): Promise<boolean> {
    mockLog(TAG, 'isRewardedAdReadyAsync → true')
    await createMockDelay(MOCK_DELAYS.short)
    return true
  }

  async isInterstitialAdReadyAsync(): Promise<boolean> {
    mockLog(TAG, 'isInterstitialAdReadyAsync → true')
    await createMockDelay(MOCK_DELAYS.short)
    return true
  }

  async showRewardedAdAsync(options?: ShowRewardedAdOptions): Promise<boolean> {
    mockLog(TAG, 'showRewardedAdAsync')
    await this.mockOverlay.showAdOverlay('rewarded', options)
    return true
  }

  async showInterstitialAd(options?: ShowInterstitialAdOptions): Promise<boolean> {
    mockLog(TAG, 'showInterstitialAd')
    await this.mockOverlay.showAdOverlay('interstitial', options)
    return true
  }
}
